const db = require('./mime.json')

module.exports = {
    fetch (mime) {
        if (db.hasOwnProperty(mime)) {
            return db[mime]
        } else {
            return db['application/octet-stream']
        }
    },
    isImage (mime) {
        return /image.*/.test(mime)
    }
}



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/std/mime.js